const HOURGLASS_RECORD_TRACE_ID_TOKEN = 'HOURGLASS_RECORD_TRACE_ID_TOKEN';

export function getHourglassId() {
    try {
        const data = localStorage.getItem(HOURGLASS_RECORD_TRACE_ID_TOKEN);
        if (!data) return null;
        const dataObj = JSON.parse(data) as any;
        return dataObj.data as string;
    } catch (err) {
        return null;
    }
}
